import * as React from "react";

const MagnifyingIcon = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.8748 4.5C14.3956 4.5 17.2498 7.35418 17.2498 10.875C17.2498 14.3958 14.3956 17.25 10.8748 17.25C7.354 17.25 4.49982 14.3958 4.49982 10.875C4.49982 7.35418 7.354 4.5 10.8748 4.5Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.443 16.4434L20.9993 20.9997"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default MagnifyingIcon;
